import { SubSectionHeaderType } from '../Section/SubSectionHeaderType';

export interface HeaderHelmetProps {
  label?: string;
  hasBenchmarkAnalysis?: boolean;
  subSectionHeaderType?: SubSectionHeaderType;
}

export default function HeaderHelmet({
  label = '',
  hasBenchmarkAnalysis,
  subSectionHeaderType
}: HeaderHelmetProps) {
  return (
    <>
      <h5>{label}</h5>
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden={!hasBenchmarkAnalysis} className="align-center">
        {hasBenchmarkAnalysis ? 'Benchmark' : ''}
      </h5>
    </>
  );
}
